import { Builder, getHeaders, getQueryString } from './utils';
import { DataApiInputParams } from 'src/types/api';
import groupBy from 'lodash/groupBy';

export default (builder: Builder) => {
  return {
    getLookups: builder.query({
      async queryFn(
        arg: DataApiInputParams,
        { getState },
        extraOptions,
        fetchWithBQ
      ) {
        let url = `fw/lookups?${getQueryString(arg.params)}`;
        let result: any = await fetchWithBQ({
          url: url,
          ...getHeaders(url)
        });
        return result.error
          ? result
          : { data: groupBy(result?.data?.data, 'type_code') };
      },
      providesTags: ['Tags']
    }),
    getTags: builder.query({
      async queryFn(
        arg: DataApiInputParams,
        { getState },
        extraOptions,
        fetchWithBQ
      ) {
        let url = `fw/tags?${getQueryString(arg.params)}`;
        return fetchWithBQ({
          url: url,
          ...getHeaders(url)
        });
      },
      providesTags: ['Tags']
    })
  };
};
